import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Menu } from './menu-item-shared';
import { adminMenu } from './admin-menu-items';
import { maintenanceMenu } from './station-maintenance-menu-items';
import { driverMenu } from './driver-menu-items';
import { autoExportMenu } from './auto-export-menu-items';
import { dashboardMenu } from './dashboard-menu-items';
import { reportsMenu } from './reports-menu-items';
import { statisticsMenu } from './statistics-menu-items';
import { stationsMenu } from './stations-menu-items';
import { accountMenu } from './account-menu-items';
import { pricingMenu } from './pricing-menu-items';

@Injectable()
export class MenuItems {
  constructor(private authService: AuthService) {}

  /**
   * Filter out items which are not allowed to the user based on his features
   */
  public allowedMenuItems(): Menu[] {
    return this.filterMenuItems([
      dashboardMenu,
      stationsMenu,
      pricingMenu,
      reportsMenu,
      statisticsMenu,
      autoExportMenu,
      maintenanceMenu,
      accountMenu,
      driverMenu,
      adminMenu,
    ]);
  }

  private filterMenuItems(menus: Menu[]): Menu[] {
    if (!menus) {
      return [];
    }

    return menus.filter((menu) => {
      const hasFeatures = this.authService.hasFeatures(menu.requiredFeatures);

      if (hasFeatures || this.showMenuForLicenseInformation(menu.name)) {
        menu.children = this.filterMenuItems(menu.children);
      }

      return hasFeatures || this.showMenuForLicenseInformation(menu.name);
    });
  }

  /**
   * The menu points should be visible even the user don't have the permission.
   * He will be redirected to the license information page from the AuthGuard.
   */
  private showMenuForLicenseInformation(name: string): boolean {
    return (
      name === 'menu.reports' ||
      name === 'menu.statistics' ||
      name === 'menu.price-plans' ||
      name === 'menu.maintenance' ||
      name === 'menu.maintenance.actions' ||
      name === 'menu.maintenance.logs' ||
      name === 'menu.maintenance.alerts'
    );
  }
}
